import {useRef} from 'react';
import {motion,useMotionValue,useSpring} from 'framer-motion';

function Magnetic({children, strength = 0.3}) {
  const ref = useRef(null);
  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const sx = useSpring(x, {stiffness: 220, damping: 16});
  const sy = useSpring(y, {stiffness: 220, damping: 16});

  const move = (e) => {
    const r = ref.current.getBoundingClientRect();
    x.set((e.clientX - (r.left + r.width / 2)) * strength);
    y.set((e.clientY - (r.top + r.height / 2)) * strength);
  };
  const leave = () => {
    x.set(0);
    y.set(0);
  };

  return (
    <motion.div
      ref={ref}
      onMouseMove={move}
      onMouseLeave={leave}
      style={{x: sx, y: sy, display: 'inline-block'}}
    >
      {children}
    </motion.div>
  );
}

export default Magnetic;
